import React from 'react'
import './Sidebar.scss'
import Menu from './Menu'


export default class Sidebar extends React.Component {

    state = {
        selected: 0
    }

    handleMenuSelect(item, index) {
        this.setState({selected: index})

        if(this.props.menuSelect) {
            this.props.menuSelect(item.value)
        }
    }

    
    render() {

        return (
            <div className="sidebar">
            
                <div className="sidebar-logo">
                    <img src={require('../../assets/admin-logo.png')} alt="LOGO" />
                    <div className="title">Hunt Country Admin</div>
                </div>

                <div className="sidebar-menu">
                    
                    <div className="sidebar-title">Admin Menu</div>
                    
                    <div className="sidebar-menu-list">
                    {
                        Menu.map((item, index) => {
                            let active = ''
                            if(index === this.state.selected) {
                                active = ' active'
                            }

                            return ( 
                                <div key={index} 
                                    className={"menu-item" + active} 
                                    onClick={() => this.handleMenuSelect(item, index)}>
                                    <img src={item.icon} alt="ICON" />
                                    <div>{item.title}</div>
                                </div>
                            )
                        })
                    }
                    </div>

                </div>
            </div>
        )
    }
}
